<template>
  <div>
    <div
      v-if="!isLoadingCarts"
      class="v2-w-full"
    >
      <div v-if="isNoCartsFound">
        <V2ExploreCollection />
      </div>
      <div
        v-else-if="isMultipleCart"
        class="v2-w-full"
      >
        <!-- Multiple Carts -->
        <V2RetailerCarts :load-carts="loadCarts" />
      </div>
      <div
        v-else
        class="v2-w-full"
      >
        <!-- Single Cart -->
        <V2RetailerSingleCart />
      </div>
    </div>
    <V2Card
      v-else
      class="v2-text-center v2-p-8 v2-mt-4"
    >
      <V2Spinner />
    </V2Card>
    <V2CartModals
      import-cart-modal-id="import_from_excel_cart"
      :on-cart-import-success="loadCarts"
    />
  </div>
</template>

<script>
import { LOAD_CARTS, RESET_CART_ERRORS, RESET_EXPANDED_CARTS } from '@/store/modules/checkout-v2.module'
import { mapState } from 'vuex'
import V2Card from '@/components/v2/V2Card.vue'
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2RetailerCarts from './V2RetailerCarts.vue'
import V2RetailerSingleCart from './V2RetailerSingleCart.vue'
import V2ExploreCollection from './V2ExploreCollection.vue'
import V2CartModals from './V2CartModals.vue'

export default {
  name: 'V2RetailerCartPage',
  components: {
    V2Card,
    V2Spinner,
    V2RetailerCarts,
    V2RetailerSingleCart,
    V2ExploreCollection,
    V2CartModals,
  },
  computed: {
    ...mapState({
      isMultipleCart: state => state.checkout.isMultipleCart,
      isLoadingCarts: state => state.checkout.isLoadingCarts,
      isNoCartsFound: state => state.checkout.isNoCartsFound,
    }),
  },
  created() {
    // Reset the expanded carts
    this.$store.commit(RESET_EXPANDED_CARTS)
    // Reset the cart errors
    this.$store.commit(RESET_CART_ERRORS)
    // Load the carts
    this.loadCarts()
  },
  methods: {
    async loadCarts() {
      await this.$store.dispatch(LOAD_CARTS)
    },
  },
}
</script>
